import GrayCard from "components/gray-card";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  label: string;
  year: string;
}
const VideoRecordLabel = ({ year, label }: IProps) => {
  return (
    <Container>
      <GrayCard title="Record Label/ Year" fullWidth>
        <Typography mb="0.4" color={Colors.grey400}>
          {label}
        </Typography>
        <Typography size="s" color={Colors.grey400}>
          {year}
        </Typography>
      </GrayCard>
    </Container>
  );
};

export default VideoRecordLabel;

const Container = styled.div`
  width: 100%;
  margin-top: 2.4rem;
`;
